<template>
  <!-- <div v-if="tipo == 'legislacao' && beneficio.regra_beneficio && beneficio.regra_beneficio != '-'">
    <h5>Informações da Legislação Estadual</h5>
    <div class="legislacao-content" paddingSemCheckBox>
      <Cabecalho  beneficio v-if="beneficio.label_classe == 'Isenção' || (beneficio.zfm_alc && beneficio.subtitulo)" :titulo="beneficio.zfm_alc && beneficio.subtitulo ? beneficio.subtitulo : beneficio.label_classe" />

      <Cabecalho  beneficio v-if="beneficio.reducao" :titulo="'Redução'" :aliquota="beneficio.reducao" />
      <Cabecalho  beneficio v-if="beneficio.credito || (beneficio.regra_beneficio == 4 && beneficio.credito_uf)" :titulo="'Crédito'" :aliquota="beneficio.regra_beneficio == 4 ? beneficio.credito_uf : beneficio.credito" />
      <Cabecalho  beneficio v-if="beneficio.condicao"  :titulo="'Condição para efeito do crédito'" :aliquota="beneficio.condicao" />
      <Cabecalho  beneficio v-if="beneficio.descricao_uf"  :titulo="'Descrição'" :aliquota="beneficio.descricao_uf" />
      <Cabecalho  beneficio v-if="beneficio.base_legal_uf"  :tipo="'link'" :titulo="'Base Legal'" :aliquota="beneficio.base_legal_uf" />
      <Cabecalho  beneficio v-if="beneficio.base_legal_ato"  :tipo="'link'" :titulo="'Ato Inicial'" :aliquota="beneficio.base_legal_ato" />
      <Cabecalho  beneficio v-if="beneficio.vigencia_ato_inicio"  :tipo="'ncm'" :titulo="'De'" :aliquota="beneficio.vigencia_ato_inicio" />
      <Cabecalho  beneficio v-if="beneficio.vigencia_ato_fim"  :tipo="'ncm'" :titulo="'Até'" :aliquota="beneficio.vigencia_ato_fim" />
      <Cabecalho  beneficio v-if="beneficio.label_fundo"  :titulo="'FECP'" :aliquota="beneficio.label_fundo" />
      <Cabecalho  beneficio v-if="beneficio.base_legal_fundo"  :tipo="'link'" :titulo="'Base Legal FECP'" :aliquota="beneficio.base_legal_fundo" />
      <div class="notificacao-container">
        <Notificacao
          v-if="beneficio.alerta"

          :tipo="'alerta'"
          :texto="beneficio.alerta"
        />

        <Notificacao
          v-if="beneficio.obs_aplic"

          :tipo="'aplicabilidade'"
          :texto="beneficio.obs_aplic"
          :municipios="beneficio.aplicavel_municipios"
        />

        <Notificacao
          v-if="beneficio.obs_inaplic"

          :tipo="'inaplicabilidade'"
          :texto="beneficio.obs_inaplic"
        />
        
        <Notificacao 
          v-if="beneficio.obs"
          :tipo="'observação'"
          :texto="beneficio.obs"
        />
      </div>
    </div>
  </div>
  <div v-else-if="tipo == 'legislacao'">
    <h5>Informações da Legislação Estadual</h5>
    <div class="legislacao-content" paddingSemCheckBox>
      <Cabecalho  beneficio v-if="beneficio.label_classe == 'Isenção' || (beneficio.zfm_alc && beneficio.subtitulo)" :titulo="beneficio.zfm_alc && beneficio.subtitulo ? beneficio.subtitulo : beneficio.label_classe" />

      <Cabecalho  beneficio v-if="beneficio.reducao" :titulo="'Redução'" :aliquota="beneficio.reducao" />
      <Cabecalho  beneficio v-if="beneficio.credito_uf" :titulo="'Crédito'" :aliquota="beneficio.credito_uf" />
      <Cabecalho  beneficio v-if="beneficio.condicao"  :titulo="'Condição para efeito do crédito'" :aliquota="beneficio.condicao" />
      <Cabecalho  beneficio v-if="beneficio.ncm_uf"  :tipo="'ncm'" :titulo="'NCM'" :aliquota="beneficio.ncm_uf" />
      <Cabecalho  beneficio v-if="beneficio.ex_uf && beneficio.ex_uf != 0"  :tipo="'ncm'" :titulo="'Ex'" :aliquota="beneficio.ex_uf" />
      <Cabecalho  beneficio v-if="beneficio.descricao_uf"  :titulo="'Descrição'" :aliquota="beneficio.descricao_uf" />
      <Cabecalho  beneficio v-if="beneficio.base_legal_uf"  :tipo="'link'" :titulo="'Base Legal'" :aliquota="beneficio.base_legal_uf" />
      <Cabecalho  beneficio v-if="beneficio.base_legal_ato"  :tipo="'link'" :titulo="'Ato Inicial'" :aliquota="beneficio.base_legal_ato" />
      <Cabecalho  beneficio v-if="beneficio.vigencia_ato_inicio"  :tipo="'ncm'" :titulo="'De'" :aliquota="beneficio.vigencia_ato_inicio" />
      <Cabecalho  beneficio v-if="beneficio.vigencia_ato_fim"  :tipo="'ncm'" :titulo="'Até'" :aliquota="beneficio.vigencia_ato_fim" />
      <Cabecalho  beneficio v-if="beneficio.label_fundo"  :titulo="'FECP'" :aliquota="beneficio.label_fundo" />
      <Cabecalho  beneficio v-if="beneficio.base_legal_fundo"  :tipo="'link'" :titulo="'Base Legal FECP'" :aliquota="beneficio.base_legal_fundo" />
      <div class="notificacao-container">
        <Notificacao
          v-if="beneficio.alerta"

          :tipo="'alerta'"
          :texto="beneficio.alerta"
        />

        <Notificacao
          v-if="beneficio.obs_aplic"

          :tipo="'aplicabilidade'"
          :texto="beneficio.obs_aplic"
          :municipios="beneficio.aplicavel_municipios"
        />

        <Notificacao
          v-if="beneficio.obs_inaplic"

          :tipo="'inaplicabilidade'"
          :texto="beneficio.obs_inaplic"
        />
        
        <Notificacao 
          v-if="beneficio.obs"
          :tipo="'observação'"
          :texto="beneficio.obs"
        />
      </div>
    </div>
  </div>
  <div v-else>
    <h5>Informações de Convênio</h5>
    <div class="legislacao-content" paddingSemCheckBox>
      <Cabecalho  beneficio v-if="beneficio.label == 'Isenção'" :titulo="beneficio.label" />
      <Cabecalho  beneficio v-if="beneficio.regra_beneficio <= 5 ? beneficio.credito_mapa : beneficio.credito_convenio" :titulo="'Crédito'" :aliquota="beneficio.regra_beneficio <= 5 ? beneficio.credito_mapa : beneficio.credito_convenio" />
      <Cabecalho  beneficio v-if="beneficio.reducao_convenio" :titulo="'Redução'" :aliquota="beneficio.reducao_convenio" />
      <Cabecalho  beneficio v-if="beneficio.condicao_convenio"  :titulo="'Condição para efeito do crédito'" :aliquota="beneficio.condicao_convenio" />
      <Cabecalho  beneficio v-if="beneficio.ncm_convenio"  :tipo="'ncm'" :titulo="'NCM'" :aliquota="beneficio.ncm_convenio" />
      <Cabecalho  beneficio v-if="beneficio.ex && beneficio.ex != 0"  :tipo="'ncm'" :titulo="'Ex'" :aliquota="beneficio.ex" />
      <Cabecalho  beneficio v-if="beneficio.descricao_convenio"  :titulo="'Descrição'" :aliquota="beneficio.descricao_convenio" />
      <Cabecalho  beneficio v-if="beneficio.base_legal_convenio"  :tipo="'link'" :titulo="'Base Legal'" :aliquota="beneficio.base_legal_convenio" />
      <Cabecalho  beneficio v-if="beneficio.base_legal_ato_convenio"  :tipo="'link'" :titulo="'Ato Inicial'" :aliquota="beneficio.base_legal_ato_convenio" />
      <Cabecalho  beneficio v-if="beneficio.vigencia_ato_inicio_convenio"  :tipo="'ncm'" :titulo="'De'" :aliquota="beneficio.vigencia_ato_inicio_convenio" />
      <Cabecalho  beneficio v-if="beneficio.vigencia_ato_fim_convenio"  :tipo="'ncm'" :titulo="'Até'" :aliquota="beneficio.vigencia_ato_fim_convenio" />
      <Cabecalho  beneficio v-if="beneficio.label_fundo_convenio"  :titulo="'FECP'" :aliquota="beneficio.label_fundo_convenio" />
      <Cabecalho  beneficio v-if="beneficio.base_legal_fundo_convenio"  :tipo="'link'" :titulo="'Base Legal FECP'" :aliquota="beneficio.base_legal_fundo_convenio" />

      <div v-if="beneficio.obs_aplic_convenio || beneficio.obs_convenio" class="notificacao-container">
        <Notificacao
          v-if="beneficio.obs_aplic_convenio"

          :tipo="'aplicabilidade'"
          :texto="beneficio.obs_aplic_convenio"
        />

        <Notificacao
          v-if="beneficio.obs_inaplic"

          :tipo="'inaplicabilidade'"
          :texto="beneficio.obs_inaplic"
        />
        <Notificacao
          v-if="beneficio.obs_convenio"

          :tipo="'observação'"
          :texto="beneficio.obs_convenio"
        />
      </div>
    </div> -->

  <!-- Código comentado porque não exibia todas as variaveis necessarias -->
  <div class="legislacao-impressao" v-if="!tipo && this.regra != 2">
    <h5>Informações do convênio</h5>
    <div class="legislacao-content" paddingSemCheckBox>
      <Cabecalho
        beneficio
        v-if="beneficio.label == 'Isenção'"
        :titulo="beneficio.label"
        :aliquota="'-'"
      />
      <!-- <Cabecalho
        beneficio
        v-if="beneficio.label != 'Isenção' && beneficio.reducao"
        :titulo="'Redução'"
        :aliquota="beneficio.reducao"
      /> -->
      <Cabecalho
        beneficio
        v-if="beneficio.label != 'Isenção' && beneficio.reducao_convenio"
        :titulo="'Redução'"
        :aliquota="beneficio.reducao_convenio"
      />
      <!-- VERIFICAR CRÉDITO PRESUMIDO -->
      <Cabecalho
        beneficio
        v-if="beneficio.label == 'Crédito Presumido' && beneficio.credito"
        :titulo="'Crédito Presumido'"
        :aliquota="beneficio.credito"
      />

      <Cabecalho
        beneficio
        v-if="beneficio.credito_mapa"
        :titulo="'Crédito'"
        :aliquota="beneficio.credito_mapa"
      />
      <Cabecalho
        beneficio
        v-if="
          beneficio.credito &&
            beneficio.condicao_credito_mapa &&
            beneficio.condicao_credito_mapa != '-'
        "
        :titulo="'Condição para efeito do crédito'"
        :aliquota="beneficio.condicao_credito_mapa"
      />
      <Cabecalho
        beneficio
        v-if="beneficio.ncm_convenio"
        :tipo="'ncm'"
        :titulo="'NCM'"
        :aliquota="beneficio.ncm_convenio != '-' ? beneficio.ncm_convenio : 'Não estabelece'"
      />
      <Cabecalho
        beneficio
        v-if="beneficio.descricao_convenio"
        :titulo="'Descrição'"
        :aliquota="
          beneficio.ex && beneficio.ex != 0
            ? `Ex: ${beneficio.ex} - ${beneficio.descricao_convenio}`
            : beneficio.descricao_convenio
        "
      />
      <!-- <Cabecalho  beneficio v-if="beneficio.descricao"  :titulo="'Descrição'" :aliquota="beneficio.ex && beneficio.ex != 0 ? `Ex: ${beneficio.ex} - ${beneficio.descricao}` : beneficio.descricao" /> -->
      <Cabecalho
        beneficio
        v-if="beneficio.base_legal_convenio"
        :tipo="'link'"
        :titulo="'Base Legal'"
        :aliquota="beneficio.base_legal_convenio"
      />
      <div class="notificacao-container">
        <Notificacao
          v-if="beneficio.obs_aplic_convenio"
          :tipo="'aplicabilidade'"
          :texto="beneficio.obs_aplic_convenio"
        />
        <Notificacao
          v-if="beneficio.obs_inaplic_convenio"
          :tipo="'inaplicabilidade'"
          :texto="beneficio.obs_inaplic_convenio"
        />
        <Notificacao
          v-if="beneficio.obs_convenio"
          :tipo="'observação'"
          :texto="beneficio.obs_convenio"
        />
      </div>
    </div>
  </div>
  <div class="legislacao-impressao" v-else-if="tipo == 'legislacao'">
    <h5>Informações da Legislação Estadual</h5>
    <div class="legislacao-content" paddingSemCheckBox>
      <Cabecalho
        beneficio
        v-if="
          ((beneficio.zfm_alc && beneficio.subtitulo) || beneficio.label == 'Isenção') &&
            this.regra != 7
        "
        :titulo="beneficio.zfm_alc ? beneficio.subtitulo : beneficio.label"
      />
      <Cabecalho
        beneficio
        v-if="beneficio.reducao && beneficio.reducao != '  '"
        :titulo="'Redução'"
        :aliquota="beneficio.reducao"
      />
      <Cabecalho
        beneficio
        v-if="beneficio.credito && (regra == 2 || regra == 3)"
        :titulo="'Crédito'"
        :aliquota="beneficio.credito"
      />
      <Cabecalho
        beneficio
        v-if="beneficio.credito_uf && (regra == 3 || regra == 6)"
        :titulo="'Crédito'"
        :aliquota="beneficio.credito_uf"
      />
      <Cabecalho
        beneficio
        v-if="beneficio.condicao && beneficio.condicao != '-' && regra == 2"
        :titulo="'Condição para efeito do crédito'"
        :aliquota="beneficio.condicao"
      />
      <Cabecalho
        beneficio
        v-if="beneficio.condicao_uf && beneficio.condicao_uf != '-' && (regra == 3 || regra == 6)"
        :titulo="'Condição para efeito do crédito'"
        :aliquota="beneficio.condicao_uf"
      />
      <Cabecalho
        beneficio
        v-if="
          beneficio.condicao_credito_uf &&
            beneficio.condicao_credito_uf != '-' &&
            (regra == 3 || regra == 6)
        "
        :titulo="'Condição para efeito do crédito'"
        :aliquota="beneficio.condicao_credito_uf"
      />
      <Cabecalho
        beneficio
        v-if="beneficio.ncm_uf && (regra == 2 || regra == 6)"
        :tipo="'ncm'"
        :titulo="'NCM'"
        :aliquota="beneficio.ncm_uf != '-' ? beneficio.ncm_uf : 'Não estabelece'"
      />
      <Cabecalho
        beneficio
        v-if="beneficio.descricao_uf && (regra == 2 || regra == 6)"
        :titulo="'Descrição'"
        :aliquota="
          beneficio.ex_uf && beneficio.ex_uf != 0
            ? `EX:${beneficio.ex_uf} - ${beneficio.descricao_uf}`
            : beneficio.descricao_uf
        "
      />
      <Cabecalho
        beneficio
        v-if="beneficio.condicao_uf && beneficio.condicao_uf != '-' && regra == 3"
        :titulo="'Condição para efeito do crédito'"
        :aliquota="beneficio.condicao_uf"
      />
      <Cabecalho
        beneficio
        v-if="beneficio.base_legal_uf && regra != 5"
        :tipo="'link'"
        :titulo="'Base Legal'"
        :aliquota="beneficio.base_legal_uf"
      />
      <Cabecalho
        beneficio
        v-if="beneficio.base_legal_ato && (regra != 4 || regra != 5)"
        :tipo="'link'"
        :titulo="'Ato Inicial'"
        :aliquota="beneficio.base_legal_ato"
      />
      <Cabecalho
        beneficio
        v-if="beneficio.vigencia_ato_inicio && (regra != 4 || regra != 5)"
        :tipo="'ncm'"
        :titulo="'De'"
        :aliquota="beneficio.vigencia_ato_inicio"
      />
      <Cabecalho
        beneficio
        v-if="beneficio.vigencia_ato_fim && (regra != 4 || regra != 5)"
        :tipo="'ncm'"
        :titulo="'Até'"
        :aliquota="beneficio.vigencia_ato_fim"
      />
      <Cabecalho
        beneficio
        v-if="beneficio.label_fundo"
        :titulo="'FECP'"
        :aliquota="beneficio.label_fundo"
      />
      <Cabecalho
        beneficio
        v-if="beneficio.base_legal_fundo"
        :tipo="'link'"
        :titulo="'Base Legal FECP'"
        :aliquota="beneficio.base_legal_fundo"
      />
      <div class="notificacao-container">
        <Notificacao
          v-if="beneficio.alerta && (this.regra == 4 || this.regra == 5)"
          :tipo="'alerta'"
          :texto="beneficio.alerta"
        />

        <Notificacao
          v-if="this.regra == 7"
          :tipo="'alerta'"
          :texto="'Esta Unidade Federada não regulamentou este convênio.'"
        />
        <Notificacao
          v-if="beneficio.obs_aplic && this.regra != 5 && this.regra != 7"
          :tipo="'aplicabilidade'"
          :texto="beneficio.obs_aplic"
          :municipios="beneficio.aplicavel_municipios"
        />
        <Notificacao
          v-if="beneficio.obs_inaplic && this.regra != 5 && this.regra != 7"
          :tipo="'inaplicabilidade'"
          :texto="beneficio.obs_inaplic"
        />
        <Notificacao
          v-if="beneficio.obs && this.regra != 5 && this.regra != 7"
          :tipo="'observação'"
          :texto="beneficio.obs"
        />
      </div>
    </div>
    <div v-if="beneficio.base_legal_uf && regra == 5" class="legislacao-content">
      <Cabecalho
        beneficio
        :tipo="'link'"
        :titulo="'Base Legal'"
        :aliquota="beneficio.base_legal_uf"
      />
    </div>
  </div>

  <!-- </div> -->
</template>

<script>
import Cabecalho from "@/components/Cabecalho/Cabecalho.vue";
import Notificacao from "@/components/Notificacao/Notificacao.vue";
import Registro from "@/components/Registro/Registro.vue";
export default {
  name: "LegislacaoEstadual",

  props: {
    tipo: String,
    beneficio: Object
  },

  components: {
    Cabecalho,
    Notificacao,
    Registro
  },

  data() {
    return {};
  },

  computed: {
    regra() {
      return this.beneficio.id_regra
        ? this.beneficio.id_regra == 1
          ? 7
          : this.beneficio.id_regra
        : this.beneficio.regra_beneficio;
    }
  }
};
</script>

<style lang="scss" scoped>
h5 {
  margin: 1rem 1rem 1rem 1.75rem;
  font-weight: 600;
  font-size: 1rem;
}

.legislacao-content {
  margin-left: 21px;
  border: 1px solid #cccccc;
}

.cabecalho-container {
  &:nth-child(odd) {
    background: #ececec;
  }
  &:nth-child(even) {
    background: #e0e0e0;
  }
  &:not(:last-child) {
    border-bottom: 1px solid #cccccc;
  }
}

.notificacao-container {
  padding: 0 0.5rem;
}

@media only print {
  .legislacao-content {
    // margin-left: 0;
    margin-right: 1.75rem;
    margin-bottom: 1.75rem;
    border: 1px solid var(--print-borda);
  }
  .legislacao-impressao {
    border: 1px solid var(--print-borda);
    page-break-inside: avoid;
    page-break-after: auto;
    margin-top: -1px;
    // border-top: none;
  }
}
</style>
